import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-16","key":"svg-0"}],["path",{"d":"M12 3v18","key":"svg-1"}]]

const IconColumns2 = createReactComponent('outline', 'columns-2', 'Columns2', __iconNode);

export default IconColumns2;